import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

import { SortType } from "@APP/types";

/**
 * Returns correct sort icon based on current state of sortBy and sortType
 */

interface Props {
  active: boolean;
  type: SortType;
}

const SortIcon = ({ active, type }: Props) => {
  if (active) {
    switch (type) {
      case SortType.desc:
        return <ExpandMoreIcon color="error" />;
      case SortType.asc:
        return <ExpandLessIcon color="error" />;
    }
  }

  return <UnfoldMoreIcon color="error" />;
};

export default SortIcon;
